// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetForm_form__2Y8Ci","error-label":"ResetForm_error-label__2LoWs"};